export const FOOTER_PAGES = [
  {
    name: "footer_page_1",
    subpages: [
      {
        name: "footer_page_1_subpage_1",
        route: "https://career.support/tracer-study/1",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_2",
        route: "https://career.support/tracer-study/2",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_3",
        route: "https://career.support/tracer-study/3",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_4",
        route: "https://career.support/tracer-study/4",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_5",
        route: "https://career.support/tracer-study/5",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_6",
        route: "https://career.support/tracer-study/6",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_7",
        route: "https://career.support/tracer-study/7",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_8",
        route: "https://career.support/tracer-study/8",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_9",
        route: "https://career.support/tracer-study/9",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_10",
        route: "https://career.support/tracer-study/10",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_11",
        route: "https://career.support/tracer-study/11",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_12",
        route: "https://career.support/tracer-study/12",
        is_url: true,
      },
      {
        name: "footer_page_1_subpage_13",
        route: "https://career.support/tracer-study/13",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_2",
    subpages: [
      {
        name: "footer_page_2_subpage_1",
        route: "https://career.support/job-fair/1",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_2",
        route: "https://career.support/job-fair/2",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_3",
        route: "https://career.support/job-fair/3",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_4",
        route: "https://career.support/job-fair/4",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_5",
        route: "https://career.support/job-fair/5",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_6",
        route: "https://career.support/job-fair/6",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_7",
        route: "https://career.support/job-fair/7",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_8",
        route: "https://career.support/job-fair/8",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_9",
        route: "https://career.support/job-fair/9",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_10",
        route: "https://career.support/job-fair/10",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_11",
        route: "https://career.support/job-fair/11",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_12",
        route: "https://career.support/job-fair/12",
        is_url: true,
      },
      {
        name: "footer_page_2_subpage_13",
        route: "https://career.support/job-fair/13",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_3",
    subpages: [
      {
        name: "footer_page_3_subpage_1",
        route: "https://career.support/career-center/1",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_2",
        route: "https://career.support/career-center/2",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_3",
        route: "https://career.support/career-center/3",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_4",
        route: "https://career.support/career-center/4",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_5",
        route: "https://career.support/career-center/5",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_6",
        route: "https://career.support/career-center/6",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_7",
        route: "https://career.support/career-center/7",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_8",
        route: "https://career.support/career-center/8",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_9",
        route: "https://career.support/career-center/9",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_10",
        route: "https://career.support/career-center/10",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_11",
        route: "https://career.support/career-center/11",
        is_url: true,
      },
      {
        name: "footer_page_3_subpage_12",
        route: "https://career.support/career-center/12",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_4",
    subpages: [
      {
        name: "footer_page_4_subpage_1",
        route: "https://career.support/csr/1",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_2",
        route: "https://career.support/csr/2",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_3",
        route: "https://career.support/csr/3",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_4",
        route: "https://career.support/csr/4",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_5",
        route: "https://career.support/csr/5",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_6",
        route: "https://career.support/csr/6",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_7",
        route: "https://career.support/csr/7",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_8",
        route: "https://career.support/csr/8",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_9",
        route: "https://career.support/csr/9",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_10",
        route: "https://career.support/csr/10",
        is_url: true,
      },
      {
        name: "footer_page_4_subpage_11",
        route: "https://career.support/csr/11",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_5",
    subpages: [
      {
        name: "footer_page_5_subpage_1",
        route: "https://career.support/hands-on/1",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_2",
        route: "https://career.support/hands-on/2",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_3",
        route: "https://career.support/hands-on/3",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_4",
        route: "https://career.support/hands-on/4",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_5",
        route: "https://career.support/hands-on/5",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_6",
        route: "https://career.support/hands-on/6",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_7",
        route: "https://career.support/hands-on/7",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_8",
        route: "https://career.support/hands-on/8",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_9",
        route: "https://career.support/hands-on/9",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_10",
        route: "https://career.support/hands-on/10",
        is_url: true,
      },
      {
        name: "footer_page_5_subpage_11",
        route: "https://career.support/hands-on/11",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_6",
    subpages: [
      {
        name: "footer_page_6_subpage_1",
        route: "https://career.support/soft-skill/1",
        is_url: true,
      },
      {
        name: "footer_page_6_subpage_2",
        route: "https://career.support/soft-skill/2",
        is_url: true,
      },
      {
        name: "footer_page_6_subpage_3",
        route: "https://career.support/soft-skill/3",
        is_url: true,
      },
    ],
  },
  {
    name: "footer_page_7",
    subpages: [
      {
        name: "footer_page_7_subpage_1",
        route: "https://career.support/entrepreneur-training/1",
        is_url: true,
      },
      {
        name: "footer_page_7_subpage_2",
        route: "https://career.support/entrepreneur-training/2",
        is_url: true,
      },
      {
        name: "footer_page_7_subpage_3",
        route: "https://career.support/entrepreneur-training/3",
        is_url: true,
      },
    ],
  },
];
